export const TOGGLE_DASHBOARD_MENU = 'src/Dashboard/TOGGLE_DASHBOARD_MENU';
export const TOGGLE_THEME = 'src/Dashboard/TOGGLE_THEME';

export const SET_IS_RANGE_SELECTION = 'src/Dashboard/SET_IS_RANGE_SELECTION';
export const SET_START_DATE = 'src/Dashboard/SET_START_DATE';
export const SET_END_DATE = 'src/Dashboard/SET_END_DATE';
export const SET_SINGLE_DATE = 'src/Dashboard/SET_SINGLE_DATE';
export const SET_FILTER_TARGET = 'src/Dashboard/SET_FILTER_TARGET';
export const RESET_DATE_SELECTION = 'src/Dashboard/RESET_DATE_SELECTION';
export const TOGGLE_FILTER_SYSTEM = 'src/Dashboard/TOGGLE_FILTER_SYSTEM';
export const SET_DASHBOARD_LOADING = 'src/Dashboard/SET_DASHBOARD_LOADING';
export const SET_DASHBOARD_ANALYTICS = 'src/Dashboard/SET_DASHBOARD_ANALYTICS';
export const SET_DASHBD_STATS_OVERVIEW = 'src/Dashboard/SET_DASHBD_STATS_OVERVIEW';
export const SET_ATTENDEES_DATA = 'src/Dashboard/SET_ATTENDEES_DATA';
export const SET_DASHBOARD_ROUTE = 'src/Dashboard/SET_DASHBOARD_ROUTE';
